import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getDateByformat } from '@common/utils/date';
import SatInput from '@components/common/satUI/SatInput';
import SatModal from '@components/common/satUI/SatModal';
import { CustomerInfoModifySmsSendPopupArea } from '@container/customer';

const RegisterInfo = props => {
  const {
    agreeDate,
    agreeStatusText,
    agreeDeleteDate,
    isOwnCustomer,
    legalAge,
    customerName = '',
    custNo = '',
    mobileTelNo = '',
    onClickRenewPopup,
    sendPlanAgreeSms,
    customerInfo,
  } = props;

  const { isRestrictedUser } = $hooks.useUser();
  const { checkCertiDate } = $hooks.useCustomer();
  const [isShowRenewMethodPopup, setIsShowRenewMethodPopup] = useState(false);
  const [isSmsSendPopupVisible, setIsSmsSendPopupVisible] = useState(false); // sms전송팝업
  const [isOpenNotAllowedUnderAgePopup, setIsOpenNotAllowedUnderAgePopup] =
    useState(false); // 미성년자 갱신 및 진단 불가 팝업

  const {
    eventDate: { joinDsgnAgreLmttDd },
  } = useSelector(state => state.commonReducer);

  const handleCheckCertiDate = () => {
    checkCertiDate(customerInfo, {
      onClose: () => setIsShowRenewMethodPopup(true),
      joinDsgnAgreLmttDd,
      hideAlert: {
        old: true,
      },
    });
  };

  useEffect(handleCheckCertiDate, []);

  return (
    <React.Fragment>
      <div className="tit-area">
        <h2 className="tit-con">가입설계동의</h2>

        <div className="side-r d-flex-center flex-gap">
          {['notExist', 'expired', 'old'].includes(
            $utils.checkCertiStatus(customerInfo, joinDsgnAgreLmttDd),
          ) && (
            <p className="text-info ico-type error">
              가입설계동의 내용 변경으로{' '}
              {joinDsgnAgreLmttDd?.startDate?.substring(0, 4)}년
              {joinDsgnAgreLmttDd?.startDate?.substring(4, 6)}월{' '}
              {joinDsgnAgreLmttDd?.startDate?.substring(6, 8)}일 이전 동의고객은
              청약 및 사전심사를 위해 가입설계동의를 다시 진행해주세요.
            </p>
          )}
        </div>
      </div>

      <div className="box two a-fs">
        <SatInput
          label={'가입설계동의'}
          value={`동의 일자 ${
            getDateByformat(agreeDate, 'yyyy.MM.dd') || ' - '
          }`}
          readOnly
        />

        <div className="half">
          <SatInput
            label={'가입 설계동의 결과'}
            value={`${agreeStatusText} ${
              isOwnCustomer
                ? `(삭제예정일 : - )`
                : `(삭제예정일 : ${
                    getDateByformat(agreeDeleteDate, 'yyyy.MM.dd') || ' - '
                  })`
            }`}
            readOnly
            suffix={() => (
              <button
                type="button"
                className="btn-s blue w-60"
                onClick={() => {
                  if (legalAge >= 19) {
                    setIsShowRenewMethodPopup(true);
                  } else {
                    // 미성년자는 갱신 불가능
                    setIsOpenNotAllowedUnderAgePopup(true);
                  }
                }}
              >
                갱신
              </button>
            )}
            // validGuide={{
            //   fixed: true,
            //   guideMsg: isOwnCustomer
            //     ? `삭제예정일 : - `
            //     : `삭제예정일 : ${
            //         getDateByformat(agreeDeleteDate, 'yyyy.MM.dd') || ' - '
            //       }`,
            // }}
          />
        </div>

        <SatModal
          onCloseButton
          visible={isShowRenewMethodPopup}
          setVisible={() => setIsShowRenewMethodPopup(false)}
        >
          <p className="layer-text text-center">
            가입 설계 동의 갱신방법을
            <br />
            선택해주세요.
          </p>
          <div className="btn-select">
            <button
              type="button"
              className="btn-face"
              onClick={() => {
                setIsShowRenewMethodPopup(false);
                onClickRenewPopup(true);
              }}
            >
              고객과 함께 동의
              <span>(대면 동의)</span>
            </button>

            {!isRestrictedUser && (
              <button
                type="button"
                className="btn-omni"
                onClick={() => {
                  setIsShowRenewMethodPopup(false);
                  setIsSmsSendPopupVisible(true);
                }}
              >
                고객에게 전송
                <span>(비대면 동의)</span>
              </button>
            )}
          </div>
        </SatModal>

        <SatModal
          visible={isSmsSendPopupVisible}
          type="confirm"
          setVisible={() => {
            setIsSmsSendPopupVisible(false);
          }}
        >
          <CustomerInfoModifySmsSendPopupArea
            customerName={customerName}
            custNo={custNo}
            mobileTelNo={mobileTelNo}
            sendPlanAgreeSms={sendPlanAgreeSms}
            setIsSmsSendPopupVisible={setIsSmsSendPopupVisible}
          />
        </SatModal>

        {/* 미성년자 갱신 및 진단 불가 팝업 */}
        <SatModal
          visible={isOpenNotAllowedUnderAgePopup}
          setVisible={() => {
            setIsOpenNotAllowedUnderAgePopup(false);
          }}
          type="info"
          msg="미성년(만19세 미만) 고객의 경우 자녀 추가를 통해 가입 설계 동의(갱신) 가능합니다."
          onOk={{
            handle: () => {
              setIsOpenNotAllowedUnderAgePopup(false);
            },
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default RegisterInfo;
